import DialogPopup from "components/molecules/DialogPopup"
import { FC, useState } from "react"
import { useTranslation } from "react-i18next"
import CountingDucks from "./games/CountingDucks"
import { ZoomIn } from "@mui/icons-material"
import { PRIMARY_BLUE } from "utils/customizedTheme"

const SectionMyWork: FC = () => {
  const { t } = useTranslation()
  const [activity, setActivity] = useState(false)
  
  const list = [
    {
      title: t('dashboard.counting-activity')
    },
    {
      title: t('dashboard.counting-activity')
    },
    {
      title: t('dashboard.counting-activity')
    },
    {
      title: t('dashboard.counting-activity')
    },
    {
      title: t('dashboard.counting-activity')
    },
    {
      title: t('dashboard.counting-activity')
    },
  ]

  return (
      <>
        <div className='grid-3'>
            {list.map((a, idx) => <div key={idx} style={{ width: '200px' }}>

                <div className='grid-3-item'
                    onClick={() => {
                        setActivity(true)
                    }}
                    >
                      <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        fontSize: '18px', 
                        fontWeight: '500', 
                        paddingBottom: '10px', 
                        cursor: 'pointer',
                        textAlign: 'center' }}>
                        <ZoomIn sx={{ color: PRIMARY_BLUE }} />
                        {a.title}
                      </div>
                    </div>
            </div>)}   
        </div>


         {activity &&
            <DialogPopup
                title={t('dashboard.counting-ducks')}
                open={!!activity}
                onClose={() => setActivity(null)}
                popupWidth={'1000px'}
            >
              <CountingDucks />
            </DialogPopup>
         }
    </>
  )
}

export default SectionMyWork
